var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Términos y condiciones")]),
        _vm._v(" "),
        _c("label", [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.estado == "N",
                  expression: "form.estado == 'N'"
                }
              ],
              staticClass: "noti-secondary"
            },
            [_vm._v("Estado: "), _c("strong", [_vm._v("NUEVO")])]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.estado == "A",
                  expression: "form.estado == 'A'"
                }
              ],
              staticClass: "noti-success"
            },
            [_vm._v("Estado: "), _c("strong", [_vm._v("ACTIVO")])]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.estado == "I",
                  expression: "form.estado == 'I'"
                }
              ],
              staticClass: "noti-danger"
            },
            [_vm._v("Estado: "), _c("strong", [_vm._v("INACTIVO")])]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "layout__main" }, [
      _c("div", { staticClass: "layout__main-form" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12 col-md-12" }, [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c(
                      "textarea-field",
                      {
                        attrs: {
                          disabled: _vm.disabledInput,
                          stretch: "",
                          id: "contenido",
                          placeholder: "Escriba el contenido..."
                        },
                        model: {
                          value: _vm.form.contenido,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "contenido", $$v)
                          },
                          expression: "form.contenido"
                        }
                      },
                      [
                        _c("span", [_vm._v("Contenido*")]),
                        _vm._v(" "),
                        _vm.errores.contenido
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.contenido[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    { staticClass: "file-upload-field" },
                    [
                      _c("label", [
                        _vm._v("Archivo PDF\n                    "),
                        _vm.errores.path_archivo
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.path_archivo[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("file-upload2", {
                        ref: "path_archivo",
                        attrs: {
                          id: "path_archivo",
                          defaultImage:
                            _vm.form.path_archivo != "" &&
                            _vm.form.path_archivo != null
                              ? _vm.url + "/images/imagen-pdf.jpg"
                              : "",
                          tamanoMaximo: 20000000,
                          descripcionMaximo: "20mb",
                          extensiones: ".pdf"
                        },
                        model: {
                          value: _vm.form.path_archivo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "path_archivo", $$v)
                          },
                          expression: "form.path_archivo"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "footer",
                  {
                    staticClass: "blockquote-footer",
                    staticStyle: { color: "#6d7684" }
                  },
                  [_vm._v(".pdf")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-2" }, [
                _c("div", { staticClass: "form-inline" }, [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.form.path_archivo.substring(0, 30) ==
                            "/storage/terminos-condiciones/",
                          expression:
                            "form.path_archivo.substring(0, 30) == '/storage/terminos-condiciones/'"
                        }
                      ],
                      staticClass: "btn-info",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.botonDescargarArchivo(
                            _vm.form.path_archivo
                          )
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-download" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.form.path_archivo != "" &&
                            _vm.form.path_archivo != null,
                          expression:
                            "form.path_archivo != '' && form.path_archivo != null"
                        }
                      ],
                      staticClass: "btn-danger",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.botonQuitarArchivo(
                            _vm.$refs.path_archivo.id
                          )
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-trash" })]
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main-buttons" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { disabled: _vm.disableButton },
                on: { click: _vm.botonGuardar }
              },
              [
                _c("i", { staticClass: "fa fa-save" }),
                _c("span", [_vm._v("Guardar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-primary btn--text",
                attrs: { disabled: _vm.disableButton },
                on: { click: _vm.botonLimpiar }
              },
              [
                _c("i", { staticClass: "fa fa-refresh" }),
                _c("span", [_vm._v("Limpiar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "btn-danger", on: { click: _vm.cerrarModal } },
              [
                _c("i", { staticClass: "fa fa-times-circle" }),
                _c("span", [_vm._v("Cerrar")])
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35dc41ef", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35dc41ef","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/terminos-condiciones/TerminosCondiciones.vue
// module id = 633
// module chunks = 0